import { useCallback, useEffect, useState } from 'react';
import { Settings } from '../settings';
export function useAbortableState(callback, dependencies, seamless = false) {
    const [result, setResult] = useState();
    const getResult = useCallback(() => {
        const controller = new AbortController();
        if (!seamless) {
            if (Settings.debug) {
                console.log('Setting state to undefined');
            }
            setResult(undefined);
        }
        const callbackResult = callback(controller.signal);
        const promise = (typeof callbackResult === 'function' ? callbackResult() : callbackResult)
            .then((results) => {
            if (!controller.signal.aborted) {
                if (Settings.debug) {
                    console.log('Results received, setting state', results);
                }
                setResult(results);
                return results;
            }
            if (Settings.debug) {
                console.log('Results received, request aborted skipping state');
            }
            return null;
        })
            .catch((e) => {
            console.error(e);
            if (Settings.debug) {
                console.log('Error, setting state to null');
            }
            setResult(null);
            return null;
        });
        return {
            abort: () => {
                controller.abort();
            },
            promise: promise,
        };
    }, [callback, seamless]);
    useEffect(() => {
        return getResult().abort;
    }, dependencies);
    const refresh = useCallback(() => getResult().promise, [getResult]);
    return [result, setResult, refresh];
}
